<template>
  <el-scrollbar class="material-check" :style="customStyle">
    <div class="item" :class="{'active': activeIndex == index}" v-for="(item, index) in list" :key="item.id" @click="handleClick(index, item)">{{ item.name }}</div>
  </el-scrollbar>
</template>

<script>
export default {
  name: 'MaterialCheck',
  props: {
    customStyle: String,
    list: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: [Number, String],
      default: 0
    }
  },
  methods: {
    handleClick(index, item) {
      this.$emit('handle-click', {index, item})
    }
  }
}
</script>

<style lang="scss" scoped>
.material-check {
  width: 136px;
  background: #FFFFFF;
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.08);
  border-radius: 20px;
  min-height: 60vh;
  padding: 20px 0;
  bottom: 0;
  .item {
    height: 60px;
    line-height: 60px;
    box-sizing: border-box;
    padding: 0 20px;
    font-weight: bold;
    color: #202020;
    font-size: 18px;
    cursor: pointer;
    &.active {
      background: #005EFF;
      color: #fff;
    }
  }
}
</style>
